// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__uLoxY","title":"footer_title__ykhLn","footerIcp":"footer_footerIcp__i4JW-"};